import { render, staticRenderFns } from "./FooterBrowserSupport.vue?vue&type=template&id=290a6218&"
import script from "./FooterBrowserSupport.vue?vue&type=script&lang=js&"
export * from "./FooterBrowserSupport.vue?vue&type=script&lang=js&"
import style0 from "./FooterBrowserSupport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports